import {Component, Input} from '@angular/core';
import {Router} from "@angular/router";
import {roles} from "../../../../shared/constants/common.constants";

@Component({
  selector: 'app-resource-card',
  templateUrl: './resource-card.component.html',
  styleUrls: ['./resource-card.component.css']
})
export class ResourceCardComponent {
  @Input() resource: any;
  allRoles = roles;
  @Input() loggedInUserRole: number = null;

  constructor(private router: Router) {
  }

  navigateToDetails() {
    const urlPrefix = this.router.url.split('/')[1];
    const url = `/${urlPrefix}/resource-hub/resource-details/${this.resource.id}/${this.resource.slug}`;
    window.open(url, '_blank');
  }
}
